import React from 'react';
import { useSportsBetting } from '../../../context/SportsBettingContext';
import { isSportsBettingPopupEnabled } from '../../../config/sportsBettingConfig';
import './SportsBettingPopup.css';

const SportsBettingPopup = () => {
  const { showPopup, hideSportsBettingPopup } = useSportsBetting();

  const handleClose = () => {
    hideSportsBettingPopup();
  };

  // Don't render popup if it's disabled
  if (!isSportsBettingPopupEnabled() || !showPopup) return null;

  return (
    <div className="sports-betting-popup-overlay">
      <div className="sports-betting-popup">
        <div className="popup-header">
          <h2>¡Atención importante!</h2>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="popup-content">
          <p>
            Estamos experimentando un problema técnico temporal que afecta las apuestas deportivas.
          </p>
         <p>
            Por el momento, no podemos ofrecer los mercados deportivos.
         </p>
         <p>
            Lamentamos la interrupción y estamos trabajando intensamente para resolver esta situación 
            lo antes posible.
          </p>
          <p>
            Agradecemos su paciencia y comprensión mientras lo solucionamos, les mantendremos 
            informados en nuestras redes sociales.
          </p>
          <p className="signature">
            Gracias por su fidelidad,
            <br />
            <strong>El equipo de Triunfador.net</strong>
          </p>
        </div>
        <div className="popup-footer">
          <button className="accept-button" onClick={handleClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default SportsBettingPopup; 